import React, { useEffect, useState } from 'react';
import { Modal, Checkbox, Button } from 'antd';
import NginxService from '../http/NginxService';
import { NginxGrayReleaseServer } from '../entities/NginxGrayReleaseServer';

interface GrayReleaseServerPickerProps {
    domainName: string;
    visible: boolean;
    onCancel: () => void;
    onConfirm: (selectedIps: string[]) => void;
    loading: boolean;
}

const GrayReleaseServerPicker: React.FC<GrayReleaseServerPickerProps> = ({ domainName, visible, onCancel, onConfirm, loading }) => {
    const [servers, setServers] = useState<NginxGrayReleaseServer[]>([]);
    const [selectedIps, setSelectedIps] = useState<string[]>([]);

    useEffect(() => {
        if (visible) {
            NginxService.listNginxGrayReleaseServers({ domainName }).then((servers) => {
                // Sort servers: enabled first, then disabled
                const sortedServers = servers.sort((a, b) => Number(a.deployed) - Number(b.deployed));
                setServers(sortedServers);
            });
        }
    }, [visible, domainName]);

    const handleCheckboxChange = (ip: string, checked: boolean) => {
        setSelectedIps(prev => checked ? [...prev, ip] : prev.filter(i => i !== ip));
    };

    const handleSelectAll = () => {
        const allEnabledIps = servers.filter(server => !server.deployed).map(server => server.ip);
        setSelectedIps(allEnabledIps);
    };

    const handleConfirm = () => {
        onConfirm(selectedIps);
    };

    return (
        <Modal
            title="选择灰度发布服务器"
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>取消</Button>,
                <Button key="selectAll" onClick={handleSelectAll} disabled={loading}>全选</Button>,
                <Button key="confirm" type="primary" onClick={handleConfirm} loading={loading}>确认</Button>
            ]}
        >
            {servers.map(server => (
                <Checkbox
                    key={server.ip}
                    checked={selectedIps.includes(server.ip)}
                    onChange={(e) => handleCheckboxChange(server.ip, e.target.checked)}
                    disabled={server.deployed || loading}>
                    {(server.deployed ? "[已部署]" : "") + server.instanceName + "（" + server.ip + "）"}
                </Checkbox>
            ))}
        </Modal>
    );
};

export default GrayReleaseServerPicker;